import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/pages/account/LoginPage'
import SignupPage from '@/pages/account/SignupPage'
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage'
import AdminUserDetail from '@/pages/admin/users/UserDetail'
import AdminUsersList from '@/pages/admin/users/UsersList'
import AdminProjectDetail from '@/pages/admin/projects/ProjectDetail'
import AdminProjectsList from '@/pages/admin/projects/ProjectsList'
import AdminContractorDetail from '@/pages/admin/contractors/ContractorDetail'
import AdminContractorsList from '@/pages/admin/contractors/ContractorsList'
import ProjectsList from '@/components/projects/ProjectsList'
import ProjectDetails from '@/components/projects/ProjectDetails'
import ForgotPassword from '@/pages/account/ForgotPassword'
import InvitePage from '@/pages/account/InvitePage'
import PkHomepage from '@/components/PkHomepage'
import auth from '@/auth'

Vue.use(Router)

function requireAuth(to, from, next) {
    if (!auth.loggedIn()) {
        console.log('Logged out')
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    } else {
        next()
    }
}

export default new Router({
    routes: [{
            path: '/admin',
            component: AdminDashboardPage,
            children: [{
                    path: '/admin/users',
                    component: AdminUsersList
                },
                {
                    path: '/admin/users/:userId',
                    component: AdminUserDetail
                },
                {
                    path: '/admin/projects',
                    component: AdminProjectsList
                },
                {
                    path: '/admin/projects/:projectId',
                    component: AdminProjectDetail
                },
                {
                    path: '/admin/contractors',
                    component: AdminContractorsList
                },
                {
                    path: '/admin/contractors/:contractorId',
                    component: AdminContractorDetail
                }
            ]
        },
        { path: '/login', component: LoginPage },
        { path: '/signup', component: SignupPage },
        { path: '/invite', component: InvitePage },
        { path: '/forgot-password', component: ForgotPassword },
        {
            path: '/i/:inviteCode',
            component: ProjectsList,
        },
        {
            path: '/',
            redirect: '/projects',
            component: PkHomepage,
        },
        {
            beforeEnter: requireAuth,
            path: '/projects',
            component: ProjectsList
        },
        {
            path: '/projects/:projectId',
            component: ProjectDetails
        }
    ]
})